const STATUS_INCOMING = 1;
const STATUS_ACTIVE = 2;
const STATUS_FINISHED = 3;

export const DEFAULT_RIVER_RUMBLE_PROTO_ID = 7948898; // @river_rumble/01_water_lilies23

export class RiverRumble {
    static #statusesNameMap = {
        [STATUS_INCOMING]: 'incoming',
        [STATUS_ACTIVE]: 'active',
        [STATUS_FINISHED]: 'finished',
    };

    static isIncoming(status) {
        return status == STATUS_INCOMING;
    }

    static isActive(status) {
        return status == STATUS_ACTIVE;
    }

    static isFinished(status) {
        return status == STATUS_FINISHED;
    }

    static getStatusName(status) {
        return RiverRumble.#statusesNameMap[status];
    }

    static getStatus(record) {
        const now = Date.now();
        const startMs = record.stime * 1000;
        const endMs = (record.stime + record.duration) * 1000;

        if (now < startMs) {
            return STATUS_INCOMING;
        }
        if (now >= startMs && now < endMs) {
            return STATUS_ACTIVE;
        }
        return STATUS_FINISHED;
    }
}

export class PeriodWithSeed {
    constructor(period, seed) {
        this.period = period;
        this.seed = seed;
    }
}

export function isRiverRumbleEditable(record) {
    const status = RiverRumble.getStatus(record);
    return (status === STATUS_INCOMING) || (status === STATUS_ACTIVE);
}

export class Random {
    constructor(seed) {
        this.seed = seed;
    }

    next() {
        this.seed = Math.imul(this.seed, 1103515245) >>> 0;
        this.seed = (this.seed + 12345) >>> 0;
        this.seed = (this.seed & 2147483647) >>> 0;
        return this.seed;
    }
}

export class Fnv32a {
    constructor(value = 2166136261) {
        this.value = value
    }

    writeUint32(i) {
        const b = [
            i & 0xFF,
            i >> 8 & 0xFF,
            i >> 16 & 0xFF,
            i >> 24 & 0xFF
        ];
        for (const c of b) {
            this.value = (this.value ^ c) >>> 0;
            this.value = Math.imul(this.value, 16777619) >>> 0;
        }
    }
}
